import { render, staticRenderFns } from "./cart.view.vue?vue&type=template&id=2ca7c23c"
import script from "./cart.view.vue?vue&type=script&lang=js"
export * from "./cart.view.vue?vue&type=script&lang=js"
import style0 from "./cart.view.vue?vue&type=style&index=0&id=2ca7c23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports